import * as z from "zod";
import { hsaSessionState } from "./types";

export const advanceHsaGroupInput = z.object({
  sessionToken: z.string().uuid(),
  // The step (group or content handle) the client just finished. Logged so a
  // stale advance is observable; the walker is the authority, so it never rejects.
  currentStepHandle: z.string().min(1),
});

export const advanceHsaGroupOutput = z.object({ state: hsaSessionState });
